import React, { Fragment, FunctionComponent } from "react";
import HomePageBlock from "./HomePage.block";
import HomePageContent from "./HomePageContent.model";

const HomePage: FunctionComponent<HomePageContent> = (props) => {
    return (
        <Fragment>
            {props.blocks?.map((blockContent: any, index) => {
                return (
                    <HomePageBlock
                        key={blockContent.contentUdi}
                        {...blockContent}
                    />
                );
            })}
        </Fragment>
    );
};

export default HomePage;
